import * as React from 'react';
import {
  Grid,
  Box,
  TextField,
} from '@material-ui/core';
import type { IStoreDetails } from './StoreInterfaces';

interface StoreOverviewProps {
  formValues: IStoreDetails;
  setFormValues: (formValues: IStoreDetails) => void;
}

const StoreOverview: React.FC<StoreOverviewProps> = ({
  formValues: StoreFormValues, setFormValues: setStoreFormValues,
}) => (
  <>
    <Box>
      <Grid container spacing={1}>
        <Grid item xs={6}>
          <Box padding={1}>
            <TextField
              value={StoreFormValues.companyName || ''}
              id="company-name-value-input"
              required
              label="Company Name"
              variant="outlined"
              type="string"
              fullWidth
              onChange={(event) => {
                const inputVal = event.target.value;
                setStoreFormValues({ ...StoreFormValues, companyName: inputVal });
              }}
            />
          </Box>
        </Grid>
        <Grid item xs={6}>
          <Box padding={1} />
        </Grid>
        <Grid item xs={6}>
          <Box padding={1}>
            <TextField
              value={StoreFormValues.name || ''}
              id="store-name-value-input"
              required
              label="Store Name"
              variant="outlined"
              type="string"
              fullWidth
              onChange={(event) => {
                const inputVal = event.target.value;
                setStoreFormValues({ ...StoreFormValues, name: inputVal });
              }}
            />
          </Box>
        </Grid>
        <Grid item xs={6}>
          <Box padding={1}>
            <TextField
              value={StoreFormValues.storeNumber || ''}
              id="store-number-value-input"
              label="Store Number"
              variant="outlined"
              type="string"
              fullWidth
              onChange={(event) => {
                const inputVal = event.target.value;
                setStoreFormValues({ ...StoreFormValues, storeNumber: inputVal });
              }}
            />
          </Box>
        </Grid>
      </Grid>
    </Box>
  </>
);

export default StoreOverview;
